import { getThemeValue } from "@theme/components";

import type { Theme } from "@emotion/react";

type KetchButtonSlot = "primary" | "secondary" | "tertiary";

const KETCH_BUTTON_SLOTS: readonly KetchButtonSlot[] = ["primary", "secondary", "tertiary"];

const slotSelector = (slot: KetchButtonSlot) => `#lanyard_root #ketch-banner-button-${slot}`;

// Ketch marks a button's theme style with these classes: filled → ketch-border-none, outline → ketch-bg-transparent.
const anyBannerButton = `#lanyard_root [id^="ketch-banner-button-"]`;
const filledSelector = `${anyBannerButton}.ketch-border-none`;
const outlinedSelector = `${anyBannerButton}.ketch-bg-transparent`;

export const ketchBannerButtonCss = (theme: Theme) => `
    ${KETCH_BUTTON_SLOTS.map(slotSelector).join(",\n")} {
      font-size: 19px !important;
      height: 44px !important;
    }

    ${filledSelector}:hover {
      background-image: none !important;
      background-color: ${getThemeValue(theme, "colors.backgroundInverse")} !important;
    }

    ${filledSelector}:focus-visible {
      background-image: none !important;
      outline-color: ${getThemeValue(theme, "colors.borderBrand")} !important;
    }

    ${outlinedSelector}:hover,
    ${outlinedSelector}:focus-visible {
      background-image: none !important;
      border-color: ${getThemeValue(theme, "colors.borderPrimary")} !important;
      color: ${getThemeValue(theme, "colors.textPrimary")} !important;
      outline: none !important;
    }
`;
